import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '@teivor/shared-utils/api';

import { Button, FormField, Input, CodeInput } from '../../lib/ui';

export function MfaPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const challengeId = params.get('challengeId') || '';
  const [code, setCode] = React.useState('');
  const [backupMode, setBackupMode] = React.useState(false);
  const [backup, setBackup] = React.useState('');
  const [error, setError] = React.useState<string | null>(null);
  const [shake, setShake] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const body = backupMode
        ? { challengeId, backupCode: backup }
        : { challengeId, code };
      await api.iam.loginMfa(body);
      navigate('/');
    } catch (err) {
      void err;
      setError(t('auth.invalid_credentials'));
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h1 className="mb-1 text-2xl font-semibold">{t('auth.mfa_required')}</h1>
      <p className="mb-6 text-sm text-[var(--color-fg-secondary)]">
        {backupMode ? t('auth.use_backup_code') : t('auth.mfa_code')}
      </p>
      {error ? (
        <div role="alert" className="mb-4 rounded-[var(--radius-md)] border border-[var(--color-danger)] bg-[var(--color-surface-2)] p-3 text-sm text-[var(--color-danger)]">
          {error}
        </div>
      ) : null}
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div className={shake ? 'animate-pulse' : ''}>
          {backupMode ? (
            <FormField label={t('auth.use_backup_code')} htmlFor="backup">
              <Input id="backup" value={backup} onChange={(e) => setBackup(e.target.value)} autoComplete="one-time-code" />
            </FormField>
          ) : (
            <CodeInput value={code} onChange={setCode} autoFocus aria-label={t('auth.mfa_code')} />
          )}
        </div>
        <Button type="submit" fullWidth loading={submitting} disabled={backupMode ? backup.length < 6 : code.length < 6}>
          {t('auth.verify')}
        </Button>
        <button
          type="button"
          onClick={() => {
            setBackupMode((m) => !m);
            setError(null);
          }}
          className="inline-flex min-h-11 items-center justify-center text-center text-sm text-[var(--color-accent)] hover:underline"
        >
          {backupMode ? t('auth.mfa_code') : t('auth.use_backup_code')}
        </button>
      </form>
    </div>
  );
}
